import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';
import {
  withRouter,
} from '@vroskus/library-navigation';

import {
  actions as mainActions,
} from '../../../redux/modules/main';

import AdminCrewmemberSocialUsersPageView from './AdminCrewmemberSocialUsersPageView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './AdminCrewmemberSocialUsersPageView';

const mapStateToProps = (): $StateProps => Object.freeze({
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(AdminCrewmemberSocialUsersPageView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const RoutedComponent = withRouter(TranslatedComponent);

const Component = RoutedComponent;

export default Component;
